import AuditStep1 from '../../AuditCreationModal/AuditStep1/AuditStep1';

const ProcessAuditStep1 = (props) => {
	return <AuditStep1 {...props} hideSchedule />;
};

export default ProcessAuditStep1;
